<template>
    <BaseButton theme="neutral" size="sm" class="w-full flex items-center justify-center gap-2" :aria-pressed="isPrioritized" :disabled="disabled" @click="emit('click')">
        <i class="bi text-base leading-none" :class="isPrioritized ? 'bi-star-fill' : 'bi-star'" aria-hidden="true"></i>
        {{ isPrioritized ? prioritizedText : unprioritizedText }}
    </BaseButton>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";

const {
    isPrioritized = false,
    prioritizedText = "Remove from priority goals",
    unprioritizedText = "Make this a priority goal",
    disabled = false,
} = defineProps<{
    isPrioritized?: boolean;
    prioritizedText?: string;
    unprioritizedText?: string;
    disabled?: boolean;
}>();

const emit = defineEmits<{ click: [] }>();
</script>
